import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { zodResolver } from "@hookform/resolvers/zod";
import { DefaultFormAutocomplete } from "../../../../../../common/components/default_form_autocomplete";
import { DefaultFormMultiAutocomplete } from "../../../../../../common/components/default_form_multi_autocomplete";
import { FornecedorDropDown } from "../../../../../../common/domain/models/fornecedor_dropdown";
import { RequisicaoProdutoServicoDropDown } from "../../../../domain/models/requisicao_produto_servico_dropdown";
import { ColetaPrecoFornecedorForm, ColetaPrecoFornecedorSchema } from "../../../schemas/ColetaPrecos_cadastro/coleta_preco_fornecedor";
import { useCallback, useEffect } from "react";

/**
 * ColetaPrecoFornecedorModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  fornecedoresDropdown: FornecedorDropDown[];
  produtosServicosDropdown: RequisicaoProdutoServicoDropDown[];
  onClose: () => void;
  onSubmit: (form: ColetaPrecoFornecedorForm) => void;
  onNewFornecedor: (onSuccess: (idFornecedor: number) => void) => void;
};

export const ColetaPrecoFornecedorModal = ({
  open,
  saving,
  loading,
  fornecedoresDropdown,
  produtosServicosDropdown,
  onClose,
  onSubmit,
  onNewFornecedor,
}: Props) => {
  const hookForm = useForm<ColetaPrecoFornecedorForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(ColetaPrecoFornecedorSchema),
  });

  useEffect(() => {
    hookForm.reset();
  }, [
    open,
    hookForm,
  ]);

  const handleNewFornecedor = useCallback((idFornecedor: number) => {
    hookForm.setValue('fornecedor', idFornecedor);
  }, [
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      width="50rem"
      title='Coleta de Preço por Fornecedor'
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <div className="w-full flex flex-col gap-4 py-4">

        <DefaultFormAutocomplete
          name='fornecedor'
          label='Selecione o fornecedor para nova coleta'
          options={fornecedoresDropdown}
          getOptionKey={x => x.idFornecedor}
          getOptionLabel={x => x.nomeFantasia}
          reactHookForm={hookForm}
          onNew={() => onNewFornecedor(handleNewFornecedor)}
        />

        <DefaultFormMultiAutocomplete
          name='produtosServicos'
          label='Selecione os produtos/serviços para nova coleta'
          options={produtosServicosDropdown}
          getOptionKey={x => x.idRequisicaoProdutoServico}
          getOptionLabel={x => x.text ?? ''}
          reactHookForm={hookForm}
        />
      </div>
    </BaseFormControlledModal>
  );
}